import { Component } from '@angular/core';
import {FeedbackService} from "../../services/feedback.service";
import {DatePipe} from "@angular/common";
import {Feedback} from "../../models/feedback";

@Component({
    selector: 'app-feedback',
    templateUrl: './feedback.component.html',
    styleUrl: './feedback.component.css',
    standalone: false
})
export class FeedbackComponent {
  loading = true;
  public colunas = [`Texto`, 'Usuário', 'Data Cadastro'];
  public linhas: any[] = [];

  constructor(private feedbackService: FeedbackService,
              private datePipe: DatePipe) {
    this.buscarLista();
  }

  private buscarLista(){
    this.feedbackService.listar().subscribe(response => {
      if(response.sucesso){
        this.preencherLista(response.dados)
      }
    });
    this.loading = false;
  }

  private preencherLista(listaItens: Feedback[]){
    for(let item of listaItens) {
      let stringArray: string[] = [];

      stringArray.push(item.texto, item.usuario, <string>this.datePipe.transform(item.dataCadastro, 'dd/MM/yyyy'));
      this.linhas.push(stringArray);
    }
  }
}
